import { Component, OnInit, Input, Output, EventEmitter, ElementRef } from '@angular/core';
import { CfCoreComponent } from '../core/core.component';
import { IconModel } from '../../models/icon/icon.model';
import { ButtonModel } from '../../models/button/button.model';
import { WizardNavButtonsStylingModel } from '../../models/wizard/wizard-nav-buttons-styling.model';
import { WizardTemplates } from '../../templates/wizard.template';
import { TemplateService } from '../../services/template-service/template.service';
/**
 * <p>Wizard Next component based on cf-button</p>
 * <p>Example of using:</p>
 * <pre>
 * <code><</code>cf-wizard-next [properties]="myWizard" [styling]="myWizardStyles"<code>></code>
 * <code><</code><code>/</code>cf-wizard-next<code>></code>
 * </pre>
 */
export class CfWizardNextComponent extends CfCoreComponent implements OnInit {
/**
 * ButtonModel object
 */
properties: ButtonModel;
/**
 * Styling object consists of two properties: contaiter and buttonStyling
 * <h4>container: StylingModel</h4>
 * Styling properties for cf-wizard-next container
 * <h4>buttonStyling: ButtonStylingModel</h4>
 * Styling properties for cf-wizard-next button
 */
styling: WizardNavButtonsStylingModel;
/**
 * <p> The label for the button</p>
 * @param {?} value
 * @return {?}
 */
set label(value: string) { this.properties.label = value; }
/**
 * <p> The name of the icon. Refer to icon component.</p>
 * @param {?} value
 * @return {?}
 */
set iconName(value: string) {
    if (this.properties.iconProperty == null) { this.properties.iconProperty = new IconModel(); }
    this.properties.iconProperty.name = value;
  }
/**
 * <p> The name of the icon. Refer to icon component.</p>
 * @param {?} value
 * @return {?}
 */
set iconSize(value: string) {
    if (this.properties.iconProperty == null) { this.properties.iconProperty = new IconModel(); }
    this.properties.iconProperty.size = value;
  }
/**
 * <p> The icon position on the button. Can be: left or right. Default: left.</p>
 * @param {?} value
 * @return {?}
 */
set iconPosition(value: string) { this.properties.iconPosition = value; }
/**
 * <b>Output</b>
 * <p>The event will be emitted when the button is clicked</p>
 */
onClick = new EventEmitter();
/**
 * @hidden
 * @param {?} elementRef
 * @param {?} templateService
 */
constructor(public elementRef: ElementRef, /**@hidden */ templateService: TemplateService) {
    super(elementRef, templateService);
    this.properties = new ButtonModel();
    this.styling = new WizardNavButtonsStylingModel();
  }
/**
 * @hidden
 * @return {?}
 */
ngOnInit() {
    this.getMyTemplate('wizard', WizardTemplates).then(() => {
      this.mergeProperties(this.activeTemplate.property['nextButton'], this.properties, 'WIZARD-NEXT').then(sampler => {
        // console.log('WIZARD-NEXT', this);
      });
    });
  }
/**
 * @hidden
 * @return {?}
 */
onNextClick() { this.onClick.emit(); }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'cf-wizard-next',
  template: "<div *ngIf=\"_inited && properties?.display\" class=\"{{activeTemplate.style?.container?.class}} {{styling?.container?.class}} {{getDynamicClasses(activeTemplate.style?.container?.dynamicClass)}} {{getDynamicClasses(styling?.container?.dynamicClass)}}\" [ngClass]=\"'cf-wizard-next'\"> <cf-button (onClick)=\"onNextClick()\" [disable]=\"properties?.disable\" [properties]=\"properties\" [styling]=\"styling?.buttonStyling\"> <ng-content></ng-content> </cf-button> </div>",
  styles: [""]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: TemplateService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'properties': [{ type: Input },],
'styling': [{ type: Input },],
'label': [{ type: Input, args: ['label', ] },],
'iconName': [{ type: Input, args: ['iconName', ] },],
'iconSize': [{ type: Input, args: ['iconSize', ] },],
'iconPosition': [{ type: Input, args: ['iconPosition', ] },],
'onClick': [{ type: Output },],
};
}

function CfWizardNextComponent_tsickle_Closure_declarations() {
/** @type {?} */
CfWizardNextComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfWizardNextComponent.ctorParameters;
/** @type {?} */
CfWizardNextComponent.propDecorators;
/**
 * ButtonModel object
 * @type {?}
 */
CfWizardNextComponent.prototype.properties;
/**
 * Styling object consists of two properties: contaiter and buttonStyling
 * <h4>container: StylingModel</h4>
 * Styling properties for cf-wizard-next container
 * <h4>buttonStyling: ButtonStylingModel</h4>
 * Styling properties for cf-wizard-next button
 * @type {?}
 */
CfWizardNextComponent.prototype.styling;
/**
 * <b>Output</b>
 * <p>The event will be emitted when the button is clicked</p>
 * @type {?}
 */
CfWizardNextComponent.prototype.onClick;
/** @type {?} */
CfWizardNextComponent.prototype.elementRef;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
